
import { IconCsv, IconFile, IconFileMusic, IconFileTypeCsv, IconFileTypeDoc, IconFileTypeHtml, IconFileTypePdf, IconFileTypePpt, IconMicrophone, IconPaperclip, IconPhoto, IconPhotoVideo, IconPlayerPlay, IconPlayerRecord, IconVideo } from "@tabler/icons-react";

export function getFileLogo(file, icon_props) {
    const ext = file?.file_url || "";
    if (ext.endsWith(".pdf")) {
        return <IconFileTypePdf {...icon_props} />;
    }
    if (file.type === "image" || ext.endsWith(".jpg") || ext.endsWith(".jpeg") || ext.endsWith(".png") || ext.endsWith(".gif") || ext.endsWith(".bmp") || ext.endsWith(".svg")) {
        return <IconPhoto {...icon_props} />;
    }
    if (file.type === "video") {
        return <IconVideo {...icon_props} />;
    }
    if (file.type === "audio" || ext.endsWith(".mp3") || ext.endsWith(".wav") || ext.endsWith(".m4a")) {
        return <IconFileMusic {...icon_props} />;
    }
    if (file.type === "excel") {
        return <IconFileTypeCsv {...icon_props} />;
    }
    if (file.type === "powerpoint") {
        return <IconFileTypePpt {...icon_props} />;
    }
    if (file.type === "docs") {
        return <IconFileTypeDoc {...icon_props} />;
    }
    if (ext.endsWith(".html")) {
        return <IconFileTypeHtml {...icon_props} />;
    }
    return <IconFile {...icon_props} />;
}


export function getAttachmentIcon(attachment, icon_props) {
    const ext = attachment?.name || attachment?.download_url || attachment?.file_url || "";
    
    if (attachment?.type === "image" || attachment?.type?.includes("mage") || ext.endsWith(".jpg") || ext.endsWith(".jpeg") || ext.endsWith(".png") || ext.endsWith(".gif") || ext.endsWith(".bmp") || ext.endsWith(".svg")) {
        return <IconPhoto {...icon_props} />;
    }
    if (attachment?.type === "video") {
        return <IconVideo {...icon_props} />;
    }
    if (attachment?.type === "audio" || ext.endsWith(".mp3") || ext.endsWith(".wav") || ext.endsWith(".m4a")) {
        return <IconMicrophone {...icon_props} />;
    }
    if (attachment?.type === "excel") {
        return <IconCsv {...icon_props} />;
    }
    if (attachment?.type === "powerpoint") {
        return <IconFileTypePpt {...icon_props} />;
    }
    if (attachment?.type === "docs") {
        return <IconFileTypeDoc {...icon_props} />;
    }
    if (ext.endsWith(".pdf")) {
        return <IconFileTypePdf {...icon_props} />;
    }
    if (ext.endsWith(".html")) {
        return <IconFileTypeHtml {...icon_props} />;
    }
    return <IconPaperclip {...icon_props} />;
}